import React, { useState, useEffect, useRef } from 'react';
import { translation } from 'easit--localization';

export interface IEventAction {
    imageMapCode: string;
    matchTime: number;
    name: string;
}

export interface IEventActionsProps {
    actions: IEventAction[];
    collapsedTitle?: React.ReactNode;
    externalExpandTrigger?: number;
    onToggle?: (isActionsExpanded: boolean) => void;
}

export const EventActionItem = (action: IEventAction) => {
    return <div className="event-action-item">
        <span className="action-match-time">{action.matchTime}{action.matchTime && <span>'</span>}</span>
        <span className={`icon-action icon-action-${action.imageMapCode}`}></span>
        {action.name}
    </div>
}
export const EventActions = (props: IEventActionsProps) => {

    const [isActionsExpanded, setIsActionsExpanded] = useState<boolean>(false);
    const actions = useRef(null);

    useEffect(() => {
        if (props.externalExpandTrigger) {
            toogleExpand(!isActionsExpanded)
        }
    }, [props.externalExpandTrigger]);

    const toogleExpand = (shouldExpand: boolean) => {
        setIsActionsExpanded(shouldExpand);
        props.onToggle(shouldExpand);
    }

    return <>
        {
            <div className="actions-collapsed d-flex align-items-center" onClick={(e) => { e.stopPropagation(); toogleExpand(!isActionsExpanded) }}>
                {
                    props.collapsedTitle &&
                    <>
                        {
                            isActionsExpanded
                                ? <span className="fa fa fa-caret-down ml-3"></span>
                                : <span className="fa fa fa-caret-right ml-3"></span>
                        }
                    </>
                }
                <span className="actions-link">{props.collapsedTitle != null ? props.collapsedTitle : '...'}</span>
            </div>
        }
        {
            isActionsExpanded &&
            <div className="event-actions-wrapper" onClick={() => toogleExpand(false)}>
                <div className="event-actions-header">
                    {translation().live_TimelineTitle}
                    <span className="fa fa-angle-down"></span>
                </div>
                <div className="actions-content" ref={actions}>
                    {
                        props.actions.length > 0 ?
                            props.actions.map((action, idx) => <EventActionItem {...action} key={idx} />)
                            : "-"
                    }
                </div>
            </div>
        }
    </>
}